import { jsx, Fragment } from 'react/jsx-runtime';
import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import { truncateTextWithinElement } from '@fabric-app/utils/text';
import { useState } from 'react';

const Truncator = ({ text, maxRows, ellipsis = "…", offsetBefore = 0, keepLastChars = 0, parentRef }) => {
  const [truncatedText, setTruncatedText] = useState(text);
  useClientLayoutEffect(() => {
    if (!parentRef) return;
    setTruncatedText(truncateTextWithinElement(text, {
      maxRows,
      ellipsis,
      element: parentRef,
      offsetBefore,
      keepLastChars
    }));
    let timeout;
    const onResize = () => {
      if (timeout) clearTimeout(timeout);
      timeout = window.setTimeout(() => {
        setTruncatedText(truncateTextWithinElement(text, {
          maxRows,
          ellipsis,
          element: parentRef,
          offsetBefore,
          keepLastChars
        }));
      }, 200);
    };
    const observer = new ResizeObserver(onResize);
    observer.observe(parentRef);
    return () => {
      observer.disconnect();
      if (timeout) clearTimeout(timeout);
    };
  }, [
    text,
    maxRows,
    ellipsis,
    parentRef,
    offsetBefore,
    keepLastChars
  ]);
  return /* @__PURE__ */ jsx(Fragment, {
    children: truncatedText
  });
};

export { Truncator as default };
//# sourceMappingURL=Truncator.js.map
